import axios from 'axios'
import { Message } from 'element-ui'
import { baseURL } from '../config/App'
import router from '../router/index'

const service = axios.create({
  baseURL,
  timeout: 5000
})
service.interceptors.request.use(config => {
  if (router.currentRoute.path === '/login') {
    config.withCredentials = true
    return config
  } else {
    config.headers.common.Authorization = localStorage.getItem('token')
    return config
  }
})

service.interceptors.response.use(response => {
  return response
}, err => {
  if (err.response.status === 401) {
    localStorage.removeItem('token')
    router.replace({
      path: '/login'
    })
  } else if (err.response.status === 402) {
    Message.error(err.response.msg)
  }
  return Promise.reject(err)
})
export default service
